import { render } from "./SentenceExplanationPanel.vue?vue&type=template&id=504f586c&scoped=true"
import script from "./SentenceExplanationPanel.vue?vue&type=script&lang=js"
export * from "./SentenceExplanationPanel.vue?vue&type=script&lang=js"

import "./SentenceExplanationPanel.vue?vue&type=style&index=0&id=504f586c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504f586c"]])

export default __exports__